import { Component, Input, OnInit } from '@angular/core';
import { EditorInputField } from '../../../editor-container/editor-model';

@Component({
  selector: 'kve-single-measure',
  templateUrl: './single-measure.component.html',
  styleUrls: ['./single-measure.component.scss']
})
export class SingleMeasureComponent implements OnInit {
  @Input() field:EditorInputField;
  
  constructor() { }

  ngOnInit(): void {
  }

}
